var React = require('react');

function ArrowsAltV (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M88 378V134.08h80V378z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M42 134.08h171.94c21.4 0 32.09-25.87 17-41L145 7a24 24 0 0 0-33.89 0L25 93.09c-15 15.15-4.32 40.99 17 40.99zM213.94 378H42.14c-21.4 0-32.09 25.88-17 41l86 86a24 24 0 0 0 33.86 0l85.93-86c15.07-15.23 4.4-41-16.99-41z","className":"fa-primary","key":2})]);
}

ArrowsAltV.defaultProps = {"viewBox":"0 0 256 512","className":"icon"};

module.exports = ArrowsAltV;

ArrowsAltV.default = ArrowsAltV;
